(() => {
  const observed = new WeakSet();
  const originalHandles = new WeakMap();
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function updateCards(modal) {
    const root = modal.querySelector('[data-case-switcher]');
    if (!root) return;
    let payload;
    try { payload = JSON.parse(root.querySelector('[data-case-switcher-payload]').textContent); } catch { return; }
    const picker = modal.querySelector('variant-picker');
    const variant = picker?.selectedVariant || payload.current.variant;
    const index = payload.current.options.findIndex(option => /model|modell|malli/i.test(option.name));
    const model = variant?.options?.[index] || variant?.['option' + (index + 1)] || payload.current.variant?.['option' + (index + 1)];
    if (!model) return;
    root.querySelectorAll('.case-type-card').forEach(card => {
      const sibling = payload.siblings[card.dataset.type];
      const match = sibling?.variants?.find(item => normalize(item.model) === normalize(model));
      const show = !!match;
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      if (match) {
        const url = new URL(sibling.url, location.origin);
        url.searchParams.set('variant', match.variant_id);
        card.href = url.pathname + url.search;
        if (card.classList.contains('active')) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      }
    });
  }
  function observe(modal) {
    if (!modal || observed.has(modal)) return;
    observed.add(modal);
    originalHandles.set(modal, modal.getAttribute('handle'));
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; updateCards(modal); });
    }).observe(modal, {childList:true, subtree:true});
  }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('.product-card__quick-add-button[aria-controls]');
    if (trigger) observe(document.getElementById(trigger.getAttribute('aria-controls')));
    const card = event.target.closest('quick-buy-modal .case-type-card');
    if (!card || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = card.closest('quick-buy-modal');
    if (!modal.hasAttribute('open')) return;
    event.preventDefault();
    event.stopPropagation();
    if (modal.getAttribute('aria-busy') === 'true') return;
    updateCards(modal);
    if (card.hidden || card.classList.contains('active')) return;
    const url = new URL(card.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    const oldHandle = modal.getAttribute('handle');
    const buttons = Array.from(modal.querySelectorAll('button[type=submit]')).map(button => [button, button.disabled]);
    buttons.forEach(([button]) => { button.disabled = true; });
    modal.setAttribute('aria-busy', 'true');
    modal.querySelector('.roar-quick-error')?.setAttribute('hidden', '');
    modal.setAttribute('handle', url.pathname.split('/products/')[1] + url.search);
    try {
      await modal.show();
      updateCards(modal);
      modal.querySelector('.case-type-card.active')?.focus({preventScroll:true});
    } catch {
      modal.setAttribute('handle', oldHandle);
      buttons.forEach(([button, disabled]) => { button.disabled = disabled; });
      modal.querySelector('.roar-quick-error')?.removeAttribute('hidden');
    } finally {
      modal.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('variant:change', event => {
    const modal = event.target.closest('quick-buy-modal');
    if (modal) requestAnimationFrame(() => updateCards(modal));
  });
  document.addEventListener('dialog:after-hide', event => {
    const modal = event.target;
    if (modal.matches?.('quick-buy-modal') && originalHandles.has(modal)) modal.setAttribute('handle', originalHandles.get(modal));
  });
})();

